<script setup>
definePage({ meta: { ...PageMeta.Quotes.Add.Meta, pageTitle: PageMeta.Quotes.Add.Title } })

import QuotesEditPage from '@/views/Previews/Quotes/QuotesEditPage.vue'

/* ** */
</script>

<template>
  <QuotesEditPage />
</template>
